import React, { FC } from 'react';
import { EvaluationDetails } from './EvaluationDetails/EvaluationDetails';

export const EvaluationDetailsPage: FC = () => {
  return <EvaluationDetails />;
};
